<div id="inicio" style="color: white; margin-bottom: -30px;">s</div>
<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="main-fad-empresa">
            <h1>
                <p>FAD® EMPRESA</p>
            </h1>
        </div>

        <div class="you-should max-width">
            <div class="text">
                <h2><p class="principal">
                    Con FAD® Empresa <br> puedes elegir <br> <span>entre 3 opciones.</span>
                </p></h2>
                <p class="secondary">
                    Y puedes cancelar en cualquier momento.
                </p>
            </div>
            <div class="picture">
                <img src="assets/images/3_opciones.png" alt="Suscripciones">
            </div>
        </div>

        <div class="options-suscriptions">
            <div class="container max-width">
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/empresa_sus_mensual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Suscripción <br> <span>Mensual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
            

                            <div class="characteristic">
                                <p class="light">
                                    Soporte:
                                </p>
                                <p class="bold">
                                    N1 Call center de Lunes a Viernes de 8am a 8pm. (N2 con costo extra)
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Incluye:
                                </p>
                                <p class="bold">
                                    App nativa (iOS y Android) opción a adquirir App Web, SDK y API.
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transacción:
                                </p>
                                <p class="bold">
                                    Videofirma + videoacuerdo + constancia de
                                    conservación + verificación por número de teléfono
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Con costo extra
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Método de pago:
                                </p>
                                <p class="bold">
                                    Tarjeta de crédito o débito
                                </p>
                            </div>

                        </mat-card-content>
                    </mat-card>

                    <div class="pricing">
                        <div id="comprar_mensual_empresa" class="option dark full" (click)="callForm(8)">
                            <p>CONTACTA A UN ASESOR</p>
                        </div>
                    </div>

                </div>

                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/prepago_anual_transaccion.png" alt="FAD Personal">
                            <div class="text">
                                <p style="font-size: 30px"><span>Prepago</span> por transacción con
                                    <span>vigencia anual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic principal">
                                <p class="light">
                                    Consulta los precios
                                    <br>con un<br>
                                </p>
                                <p class="bold">
                                    <span>Asesor de Ventas</span>
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Usuarios incluidos:
                                </p>
                                <p class="bold">
                                    1
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Número de transacciones:
                                </p>
                                <p class="bold">
                                    Desde 11 hasta 1,000,000
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Vigencia de transacciones:
                                </p>
                                <p class="bold">
                                    Anual
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transacción:
                                </p>
                                <p class="bold">
                                    Videofirma + videoacuerdo + constancia de
                                    conservación + verificación por número de teléfono
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Incluidos en los diferentes planes
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Método de pago:
                                </p>
                                <p class="bold">
                                    Consulta con tu asesor de ventas
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_anual_empresa" class="option dark full" (click)="callForm(4)">
                            <p>CONTACTA A UN ASESOR</p>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/integraciones_especiales.png" alt="FAD Personal">
                            <div class="text">
                                <p>Integraciones <br> <span>especiales</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic">
                                <p class="light">
                                    Soluciones para empresas <br> con necesidades específicas:
                                </p>
                                <p class="bold left">
                                    · API <br>
                                    · SDK <br>
                                    · Cambio de imagen <br>
                                    · Integraciones especiales <br>
                                    · Entre otros
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Contáctanos <br>
                                    y platícanos más sobre tu proyecto:
                                </p>
                                <p class="bold">
                                    <a href="tel:5553625800">+52 (55) 5362 5800</a>
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Nuestros asesores <br>
                                    se encuentran disponibles de <br>
                                </p>
                                <p class="bold">
                                    Lunes a Viernes <br>
                                    de 10am a 8pm.
                                </p>
                            </div>

                            <div class="divider"></div>

                            <div class="characteristic">
                                <p class="light">
                                    Si prefieres puedes llenar el formulario
                                    e <span class="bold">indicarnos<br>la fecha y hora</span> en la
                                    que te <span class="bold">podemos contactar.</span>
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_integracion_empresa" class="option dark full" (click)="callForm(5)">
                            <p>LLENAR FORMULARIO AHORA</p>
                        </div>
                    </div>
                </div>
            </div>

        <div id="contact-cotizar">
            <div class="options-suscriptions" *ngIf="contactForm === 4 || contactForm === 5 || contactForm === 8">
                <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                <p class="title max-width" *ngIf="contactForm === 4">
                    Ayúdanos a completar el formulario para <b>cotizar tu plan <br> prepago anual a FAD® empresa.</b>
                </p>
                <p class="title max-width" *ngIf="contactForm === 5">
                    Ayúdanos a completar el formulario para <b>platicar de tu</b> <br> <b>Integración especial FAD®</b>
                </p>
                <p class="title max-width" *ngIf="contactForm === 8">
                    Ayúdanos a completar el formulario para <b>platicar de tu</b> <br> <b> plan de suscripción mensual para empresas</b>
                </p>
                <div class="max-width" *ngIf="contactForm === 4">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="max-width" *ngIf="contactForm === 5">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="max-width" *ngIf="contactForm === 8">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
            </div>
        </div>
        </div>


        <div class="add-ons">
            <p class="title max-width">
                Tanto en la Suscripción mensual como en el Plan prepago
                puedes agregar las siguientes <span>Funcionalidades extra (Add-Ons)** :</span>
            </p>
            <p style="margin: 20px 0 0; text-align: center; font-size: 20px; margin-top: -15px;">
                <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp" style="font-weight: bold;color: var(--light-gray-color); text-decoration: none; cursor: pointer;">** Para la compra de Funcionalidades extra (Add-Ons) solicítalos con tu asesor de ventas con costo
                    extra.</a>
                <br>
                <span style="color: var(--light-gray-color);" *ngIf="this.sessionService.getCountryData()">* Más impuestos locales.</span>
            </p>
            <div class="list max-width">
                <div class="left">
                    <p class="title">
                        Funcionalidades extra
                    </p>
                    <div class="table">

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/foto_ine.png" alt="Foto INE">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación</p>
                                <p class="text-item">Fotografía de la identificación por ambos lados</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/otp_whatsap.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">OTP vía WhatsApp</p>
                                <p class="text-item">Envío de código de un sólo uso por WhatsApp, para que el firmante
                                    abra
                                    el documento a firmar en la app móvil o web</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/blockchain.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Constancia de conservación en Blockchain</p>
                                <p class="text-item">Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/version_web.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Versión WEB</p>
                                <p class="text-item">El firmante puede realizar la firma de documentos desde cualquier
                                    navegador móvil sin descargar ninguna aplicación</p>
                            </div>
                        </div>


                        <div class="row">
                            <div class="image">
                                <img src="assets/images/fotoine_firma.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con video
                                    acuerdo</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico, más una comparación entre la foto del rostro
                                    plasmada en el ID y una imagen del rostro del firmante durante el
                                    videoacuerdo</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_videofirma.png" alt="Ine, video y firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con
                                    videofirma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico, más una comparación entre la foto del rostro
                                    plasmada en el ID y una imagen del rostro del firmante durante
                                    la videofirma</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video_validacion.png"
                                     alt="Ine, comparación de firma y video firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con video
                                    acuerdo + comparación facial con videofirma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico; comparación entre la foto del rostro plasmada en el
                                    ID y una imagen del rostro del firmante durante el videoacuerdo;
                                    comparación entre la foto del rostro plasmada en el ID y
                                    una imagen del rostro del firmante durante el videofirma</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="do-you-wish">
            <p class="title max-width">
                ¿Te interesa alguna de nuestras opciones <br>
                de <span>FAD® Empresa</span>?
            </p>
            <div class="options max-width">
                <div class="item">
                    <img src="assets/images/empresa_mensual.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>Suscripción <br><span>Mensual</span></p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/empresa_prepago.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>
                            <span>Prepago anual</span><br>
                            por transacción
                        </p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/empresa_integraciones.png" alt="Suscripción Anual">
                    <div class="text">
                        <p>
                            <span>Integraciones</span><br>
                            especiales
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel id="comprar_mensual_resumen" hideToggle (click)="callForm(8)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>COTIZA HOY</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">
                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="comprar_anual_resumen" hideToggle (click)="callForm(4)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>COTIZA HOY</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="comprar_integracion_resumen" hideToggle (click)="callForm(5)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>QUIERO QUE ME LLAMEN</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">

            <div class="box-img">
                <img class="img-prin" src="assets/images/m/empresafotos.png">
            </div>

            <div class="content-res">
                <h1>FAD®<br><span>EMPRESA</span><br></h1>
                <hr>
                <h2><p class="text">
                    Con FAD® empresa puedes <strong>elegir entre tres opciones</strong> y puedes <strong>cancelar en
                    cualquier momento.</strong>
                </p></h2>
            </div>

            <div class="box-light">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Suscripción</p><span>mensual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
                            <p>Videofirma + Videoacuerdo + Constancia de conservación</p>
                            <p>N1 Call center de Lunes a Viernes de 8am a 8pm. (N2 con costo extra)</p>
                            <p>App nativa (iOS y Android) opción a adquirir App Web, SDK y API.</p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_empresa_movil" class="btn-prin" (click)="callForm(8)">
                                <p>Cotizar Ahora</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Plan prepago con </p>
                        <span>vigencia anual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">

                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_empresa_movil" class="btn-prin" (click)="callForm(4)">
                                <p>Cotizar Ahora</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Integraciones </p><span>especiales</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="margin-top: 10px; padding-bottom: 0px;">
                            <p><strong>Contáctanos</strong> y platícamos más</p>
                            <hr>
                            <p>sobre tu proyecto</p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_integracion_empresa_movil" class="btn-prin" (click)="callForm(5)">
                                <p>Quiero que me llamen</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="contact-cotizar-movil">
                <div class="content-general" *ngIf="contactForm === 4 || contactForm === 5 || contactForm === 8">
                    <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                    <div class="content-res" *ngIf="contactForm === 4">
                        <p class="title">Ayúdanos a completar el formulario para <strong>cotizar tu plan <br> prepago
                            anual a FAD® empresa.</strong></p>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 5">
                        <p class="title">Ayúdanos a completar el formulario para <strong>platicar de tu <br>Integración
                            especial FAD®</strong></p>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 8">
                        <p class="title">Ayúdanos a completar el formulario para <strong>platicar de tu <br> plan de suscripción mensual para empresas
                        </strong></p>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 4">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 5">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                    <div class="content-res" *ngIf="contactForm === 8">
                        <app-form-company-template [type]="contactForm"></app-form-company-template>
                    </div>
                </div>
            </div>

            <div class="content-general">

                <div class="content-res">
                    Agrega<br><strong>funcionalidades extra a tu paquete FAD®</strong><br>
                </div>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validación de video acuerdo</span>
                    <br>Comparación entre el rostro durante el video acuerdo y la foto de la ID</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validación de video firma</span>
                    <br>Comparación entre el rostro durante la video firma y la foto de la ID</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constancia Blockchain</span>
                    <br>Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de ID</span>
                    <br>Fotografía de documento de identidad por ambos lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP vía WhatsApp</span>
                    <br>Envío de código de un solo uso por WhatsApp, para que el firmante abra el documento a firmar en
                    la app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validación de firma</span>
                    <br>Comparación entre firma plasmada en la ID y la firma hecha con el dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versión WEB</span>
                    <br>El firmante puede realizar la firma de documentos desde cualquier navegador móvil sin descargar
                    la aplicación FAD®</p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Consideraciones importantes</span>
                    <br>1. Para realizar las comparaciones de video acuerdo, videofirma y firma,
                    es necesario adquirir la Captura de identificación. <br>
                    2. Para la compra de Add-Ons solicítalos con tu asesor de ventas
                    con costo extra.</p>

                <img height="330px" width="266px" src="assets/images/m/telefonos.png" alt="">

            </div>

        </div>

    </div>

</app-template>
